import React, { useEffect, useState } from "react";
import {
  MdLogout,
  MdOutlinePerson,
  MdOutlineShoppingBag,
} from "react-icons/md";
import { PiPasswordFill } from "react-icons/pi";
import { TbFileLike } from "react-icons/tb";
import { Link } from "react-router-dom";
import { ClientModel } from "../../entities/client.model";
import "./sidebar.scss";

interface SidebarProps {
  onLogout: () => void;
  closeMenu: () => void;
}

async function fetchMyDetails(): Promise<ClientModel> {
  const token = localStorage.getItem("clientToken");
  if (!token || token === "undefined") {
    throw new Error("Not authenticated");
  }

  const res = await fetch(`${process.env.REACT_APP_API_URL}client`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: token,
    },
  });

  if (!res.ok) {
    const err = (await res.json().catch(() => ({}))) as any;
    throw new Error(err.errorMsg || `HTTP ${res.status}`);
  }

  const payload = (await res.json()) as { client: ClientModel };
  return payload.client;
}

const Sidebar: React.FC<SidebarProps> = ({ onLogout, closeMenu }) => {
  const [client, setClient] = useState<ClientModel | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    fetchMyDetails()
      .then((c) => setClient(c))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (loading) {
    return <div className="sidebar-loading">Loading user…</div>;
  }

  return (
    <div>
      {!isMobile && (
        <div className="client-dropdown">
          {client && (
            <div className="dropdown-header">
              <div>
                <h3>{client.parentName}</h3>
                <h3>{client.ownName}</h3>
              </div>
              <p>{client.email}</p>
            </div>
          )}

          <div className="dropdown-item">
            <Link to="/client/orders" onClick={closeMenu}>
              <span className="menu-icon">
                <MdOutlineShoppingBag size={28} />
              </span>
              <span className="menu-text">Миний захиалгууд</span>
            </Link>
          </div>

          <div className="dropdown-item">
            <Link to="/client/company/child-orders" onClick={closeMenu}>
              <span className="menu-icon">
                <MdOutlineShoppingBag size={28} />
              </span>
              <span className="menu-text">Салбарын захиалгууд</span>
            </Link>
          </div>

          <div className="dropdown-item">
            <Link to="/client/account" onClick={closeMenu}>
              <span className="menu-icon">
                <MdOutlinePerson size={28} />
              </span>
              <span className="menu-text">Миний мэдээлэл</span>
            </Link>
          </div>

          <div className="dropdown-item">
            <Link to="/client/change-password" onClick={closeMenu}>
              <span className="menu-icon">
                <PiPasswordFill size={28} />
              </span>
              <span className="menu-text">Нууц үг солих</span>
            </Link>
          </div>

          {/* <div className="dropdown-item">
            <Link to="/client/company" onClick={closeMenu}>
              <span className="menu-icon">
                <Icon name="building outline" size="large" />
              </span>
              <span className="menu-text">Байгууллага</span>
            </Link>
          </div> */}

          <div className="dropdown-item">
            <Link to="/client/saved-products" onClick={closeMenu}>
              <TbFileLike size={28} />
              <span className="menu-text">Хадгалсан бараа</span>
            </Link>
          </div>

          <div className="dropdown-item3" onClick={onLogout}>
            <MdLogout size={28} />
            <span className="menu-text">Гарах</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
